//local imports
import { Messenger } from "@app/shared";


import { 
  ToastLevel,
  ToastMessage
} from "@app/components";

import { 
  CatalogStateService,
  RefreshFilterMessage,
  RoomModel
} from "@app/catalog";


import {
  RoomAddedMessage,
  RoomUpdatedMessage
} from "@app/catalog";

import {
  RoomCreatedNotification,
  RoomUpdatedNotification
} from "@app/catalog-common";

export class RoomStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      RoomCreatedNotification,
      (message: RoomCreatedNotification) => {
        let newRoom = new RoomModel();

        newRoom.id = message.roomId;

        newRoom.name.set(message.roomName);

        this.updateRoom(newRoom, message);

        catalogStateService.CatalogManagementState.rooms.set([
          newRoom,
          ...catalogStateService.CatalogManagementState.rooms(),
        ]);

        messenger.send(
          ToastMessage.create(
            new RoomAddedMessage(newRoom),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    messenger.subscribe(
      catalogStateService,
      RoomUpdatedNotification,
      (message: RoomUpdatedNotification) => {
        let room = catalogStateService.CatalogManagementState.rooms().find(
          (u) => u.id === message.roomId,
        );

        if (!room) {
          room = new RoomModel();
          room.id = message.roomId;

          room.name.set(message.roomName);
        }

        this.updateRoom(room, message);

        messenger.send(new RefreshFilterMessage());
        messenger.send(
          ToastMessage.create(
            new RoomUpdatedMessage(room),
            ToastLevel.Information,
          ),
        );
      },
    );
  }

  private updateRoom(
    room: RoomModel,
    message: RoomCreatedNotification | RoomUpdatedNotification,
  ) {
    //TODO:DIW:Move into it's own class..
    //TODO:DIW:Set properties by reading changed properties collection and mapping..

    for (let change of message.changes) {
      if (change.propertyName.toLowerCase() === "name") {
        room.name.set(change.newValue);
      } else if (change.propertyName.toLowerCase() == "code") {
        room.code.set(change.newValue);
      } else if (change.propertyName.toLowerCase() == "subCode") {
        room.subCode.set(change.newValue);
      } else if (change.propertyName.toLowerCase() == "type") {
        room.type.set(change.newValue);
      } else if (change.propertyName.toLowerCase() == "nsf") {
        room.nsf.set(change.newValue);
      }
    }
  }
}
